import { getOrRefreshToken } from "./tokens.js";

//#region src/client/util/build-request-headers.ts
const CLIENT_HEADER = "phx-client";
const buildRequestHeaders = async ({ authClientId, authTokenUrl, clientId, headers }) => {
	const accessToken = await getOrRefreshToken(authClientId, authTokenUrl);
	const customHeaders = { ...headers };
	if (accessToken) customHeaders.authorization = `Bearer ${accessToken}`;
	customHeaders[CLIENT_HEADER] = clientId;
	return customHeaders;
};

//#endregion
export { CLIENT_HEADER, buildRequestHeaders };